import React, { useEffect, useState } from "react";

const ChatSidebar = ({
  token,
  currentUser,
  onSelectConversation,
  selectedConversation,
}) => {
  const [conversations, setConversations] = useState([]);
  const [search, setSearch] = useState("");

  useEffect(() => {
    fetch("/api/conversations", {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
      .then((res) => res.json())
      .then((data) => setConversations(data));
  }, []);

  const getOtherUser = (conv) => {
    return conv.user_one_id === currentUser.id ? conv.user_two : conv.user_one;
  };

  const filtered = conversations.filter((conv) => {
    const otherUser = getOtherUser(conv);
    return otherUser.name.toLowerCase().includes(search.toLowerCase());
  });

  return (
    <div
      style={{
        width: "300px",
        borderRight: "1px solid #ccc",
        padding: "10px",
        overflowY: "auto",
      }}
    >
      <input
        type="text"
        placeholder="Search users..."
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        style={{ width: "100%", padding: "8px", marginBottom: "10px" }}
      />

      {filtered.map((conv) => {
        const otherUser = getOtherUser(conv);
        const isActive = selectedConversation?.id === conv.id;
        const lastMessage = conv.messages[0] ?? null;

        return (
          <div
            key={conv.id}
            onClick={() => onSelectConversation(conv)}
            style={{
              padding: "10px",
              marginBottom: "5px",
              background: isActive ? "#eee" : "#fff",
              cursor: "pointer",
              borderRadius: "4px",
            }}
          >
            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
              <span
                style={{
                  display: "inline-block",
                  width: "10px",
                  height: "10px",
                  borderRadius: "50%",
                  backgroundColor: otherUser.is_online ? "green" : "gray",
                }}
              />
              <strong>{otherUser.name}</strong>
            </div>
            {lastMessage && (
              <div
                style={{ fontSize: "12px", color: "#666", marginTop: "4px" }}
              >
                {lastMessage.body || "(attachment)"}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default ChatSidebar;
